module.exports = __webpack_public_path__ + "static/media/itchio.241940ff.png";